import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { LANGS } from "../lib/i18n";
import { Button } from "./ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Sparkles, Globe, LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const { t, lang, setLang } = useI18n();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass">
      <div className="mx-auto max-w-7xl flex items-center justify-between px-4 sm:px-6 h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="w-8 h-8 rounded-full grid place-items-center bg-primary/20 ring-1 ring-primary/40">
            <Sparkles className="w-4 h-4 text-primary" />
          </span>
          <span className="font-serif text-2xl gold-text tracking-tight">{t.brand}</span>
        </Link>
        <div className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" data-testid="lang-toggle" className="gap-2 rounded-full">
                <Globe className="w-4 h-4" />
                <span className="uppercase text-xs tracking-wider">{lang}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {LANGS.map((l) => (
                <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-${l.code}`}>
                  {l.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          {user ? (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard" className="gap-2">
                <LayoutDashboard className="w-4 h-4" /> <span className="hidden sm:inline">{t.dashboard}</span>
              </Button>
              {user.role === "super_admin" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin" className="gap-2">
                  <ShieldCheck className="w-4 h-4" /> <span className="hidden sm:inline">{t.admin}</span>
                </Button>
              )}
              {user.role === "jeweler" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/jeweler")} data-testid="nav-jeweler" className="gap-2">
                  <ShieldCheck className="w-4 h-4" /> <span className="hidden sm:inline">{t.jeweler_panel}</span>
                </Button>
              )}
              <Button variant="outline" size="sm" onClick={logout} data-testid="nav-logout" className="gap-2 rounded-full">
                <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">{t.logout}</span>
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login">{t.login}</Button>
              <Button size="sm" onClick={() => navigate("/register")} data-testid="nav-register" className="rounded-full">{t.register}</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
